import { Box } from "@mui/material";
import React, { ReactNode } from "react";

interface PageTopBarProps {
  children?: ReactNode;
  justifyContent?: "space-between" | "flex-end";
}

export const PageTopBar = ({ children, justifyContent: justiftContent = "flex-end" }: PageTopBarProps) => (
    <Box
        sx={{
            position: "fixed",
            zIndex: 99,
            backgroundColor: "background.paper",
            padding: "0 1rem",
            height: "48px",
            width: "calc(100vw - 176px)",
            display: "flex",
            alignItems: "center",
            justifyContent: justiftContent,
        }}
    >
        {children}
    </Box>
);
